export type { ConditionMedpraxCodes } from './mapping';
export {
  findReasonOfAdmission,
  isConditionType,
  isSameDiagnosis,
  mapActiveConditions,
  mapConditionToDiagnoses,
  mapCreateDiagnosisToFhir,
  mapDiagnosesToMedprax,
  mapFhirToDiagnosisModel,
  mapICD10ToCoding,
  mapInactiveConditions,
  mapModelToFhirDiagnosis,
  resolveConditionDifference,
} from './mapping';
export type {
  CreateDiagnosis,
  Diagnosis,
  DiagnosisGetAllResponse,
  DiagnosisSearchParams,
  GetDiagnosisResponse,
} from './schema';
export {
  CreateDiagnosisSchema,
  DiagnosisGetAllResponseSchema,
  DiagnosisSchema,
  DiagnosisSearchSchema,
  GetDiagnosisResponseSchema,
} from './schema';
